import { render, staticRenderFns } from "./tanchuang3.vue?vue&type=template&id=60caab79&scoped=true&"
import script from "./tanchuang3.vue?vue&type=script&lang=js&"
export * from "./tanchuang3.vue?vue&type=script&lang=js&"
import style0 from "./tanchuang3.vue?vue&type=style&index=0&id=60caab79&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60caab79",
  null
  
)

export default component.exports